module.exports = __webpack_public_path__ + "img/huaiyun-icon.90451d65.png";